import Info from '@assets/icons/info.svg'
import { Icon } from './Icon'

export const InfoIcon = Icon(Info)
